
import { mapMutations, mapState, mapGetters } from "vuex";

import {
  ADD_CHANNELS_STEP,
  MENU_STEPS,
  MIDDLEWARE_STEPS,
  WHATSAPP_STEPS,
  WHATSAPP_STEPS_MINIFIED,
  MIDDLEWARE_STEPS_MINIFIED
} from "../../constants/InitialSetupSteps";

export default {
  props: {
    isInitialLive: {
      type: Boolean,
      default: false
    },

    showChannelIntegrationBanner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      combinedArray: [],
      integrationStatus: ""
    };
  },
  beforeMount() {
    const whatsappSteps = WHATSAPP_STEPS;
    const middlewareSteps = MIDDLEWARE_STEPS;
    this.combinedArray = [
      ...ADD_CHANNELS_STEP,
      ...MENU_STEPS,
      ...middlewareSteps,
      ...whatsappSteps
    ];
    if (this.locationDetails?.restaurants) {
      this.integrationStatus =
        this.locationDetails?.restaurants[0]?.integration_status;
    }
  },
  watch: {
    locationDetails() {
      this.integrationStatus =
        this.locationDetails?.restaurants[0]?.integration_status;
    }
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    currentStep() {
      return this.combinedArray.findIndex(
        (el) => el.id === this.integrationStatus
      );
    },
    progressValue() {
      return (this.currentStep / this.combinedArray.length) * 100;
    }
  },
  methods: {
    ...mapMutations("reciever", ["SET_SELECTED_CHANNEL"]),

    handleViewOnboardingSteps() {
      if (this.$route.path === "/reciever") {
        this.SET_SELECTED_CHANNEL(this.$constants.Channels.WHATSAPP);
      } else {
        this.$router.push({
          name: "reciever",
          params: { showWhatsappTab: true }
        });
      }
    }
  }
};
